import React from 'react';
import * as PropTypes from 'prop-types';

const CopyRight = ({content}) => {
  const {text, organisation:{name, operates},address:{street,locality,region,postalCode}} = content;

  return (
    <div className={'copyright'}>
        <p>{text}</p>
      <div className="organisation">
        <span className={'name'}>{name}</span>
        <span className={'operate-from'}> {operates}</span>
        <div className="address">
          <span className="street"> {street}</span>
          <span className="locality"> {locality}</span><br/>
          <span className="region"> {region}</span>
          <span className="postal-code"> {postalCode}</span>
        </div>
      </div>
    </div>
  )
};

CopyRight.propTypes = {
  content:PropTypes.object
};

CopyRight.defaultProps = {
  content: {
    text: '',
    organisation: {
      name: '',
      operates: '',
    },
    address: {
      street: '',
      locality: '',
      region: '',
      postalCode: ''
    }
  }
};

export default CopyRight;